import React from 'react'

export const DataWrapperChart = ({
  chartId,
  lazy = true,
  height = 0,
  ...rest
}) => {
  React.useEffect(() => {
    const listener = event => {
      if (
        void 0 !== event.data['datawrapper-height'] &&
        chartId in event.data['datawrapper-height']
      ) {
        var t =
          document.getElementById('datawrapper-chart-' + chartId) ||
          document.querySelector("iframe[src*='" + chartId + "']")
        t && (t.style.height = event.data['datawrapper-height'][chartId] + 'px')
      }
    }
    window.addEventListener('message', listener)
    return () => window.removeEventListener('message', listener)
  }, [chartId])

  return (
    <iframe
      title='Kriterien für mögliche Verschärfungen'
      aria-label='chart'
      id={`datawrapper-chart-${chartId}`}
      src={`https://datawrapper.dwcdn.net/${chartId}/`}
      scrolling='no'
      frameBorder='0'
      loading={lazy ? 'lazy' : undefined}
      style={{
        width: 0,
        height,
        minWidth: '100%',
        border: 'none',
        marginTop: '30px',
        marginBottom: '30px'
      }}
      height={height ? height : undefined}
      {...rest}
    ></iframe>
  )
}
